import './index.less';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Skeleton, Table } from 'antd';
import { ReactComponent as AddSvg } from '../icons/add.svg';
import { ReactComponent as SearchSvg } from '../icons/search.svg';
import TnInput from '@/global/components/input/tn-input';
import { getMonitorTypeLabel } from '@/enums/monitor-type';
import dayjs from 'dayjs';
import { ReactComponent as DeleteSvg } from '@/global/icons/side-tool/delete.svg';
import { ReactComponent as EditSvg } from '@/global/icons/side-tool/edit.svg';
import TnMessage from '@/global/components/message';
import { User } from '@/global/interface/project-manage/user';
import { getUsers, updateUser } from '@/api/lib/user';
import AddUserModal from './add-user';
import { GENDER_TYPE, USER_TYPE } from '@/enums/user';
import EditUserModal from './edit-user';
import classnames from 'classnames';
import TnModal from '@/global/components/base-modal';


export default function LibUserPanel() {
    const navigate = useNavigate();
    const [users, setUsers] = useState<User[]>([]); // 用户
    const [displayUsers, setDisplayUsers] = useState<User[]>([]); // 展示用户
    const [loading, setLoading] = useState<boolean>(false); // loading
    // const [searchStr, setSearchStr] = useState<string>(''); // 搜索框值
    const [activeItem, setActiveItem] = useState<User>(null) // 激活的项

    const [showAddModal, setShowAddModal] = useState<boolean>(false); // 显示添加用户弹窗
    const [addLoading, setAddLoading] = useState<boolean>(false); // 添加弹窗loading

    const [showEditModal, setShowEditModal] = useState<boolean>(false); // 显示编辑用户弹窗
    const [editLoading, setEditLoading] = useState<boolean>(false); // 编辑弹窗loading

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // useEffect(() => {
    //     let newDisplay = users?.filter(item => item.name.toLowerCase().includes(searchStr)) || [];
    //     setDisplayUsers(newDisplay);
    // }, [searchStr])

    // 获取用户
    const generateData = () => {
        setLoading(true);
        getUsers().then(res => {
            let data = res.data || [];
            setUsers(data);
            setDisplayUsers(data);
        }).catch(err => {
            TnMessage.error("获取用户失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onEditClick = () => {
        if (!activeItem) {
            TnMessage.warning("未选中用户");
            return;
        }
        setShowEditModal(true);
    }

    const onDeleteClick = () => {
        if (!activeItem) {
            TnMessage.warning("未选中用户");
            return;
        }
        TnModal().deleteModal({
            onOk() {
                setLoading(true);
                Modal.destroyAll();
                updateUser(activeItem?.uuid, { locked: true }).then(res => {
                    if (res.status === 200) {
                        let idx = users?.findIndex(item => item?.uuid === activeItem?.uuid);
                        users.splice(idx, 1);
                        setUsers([...users]);
                        setActiveItem(null);
                        TnMessage.success("删除成功");
                    }
                }).catch(err => {
                    TnMessage.error("删除失败");
                }).finally(() => {
                    setLoading(false);
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })
    }


    return (
        <div className='user-list-panel'>
            <div className='user-header'>
                <div className="create-user-btn" onClick={() => setShowAddModal(true)}><AddSvg />添加用户</div>
                {/* <TnInput
                    value={searchStr}
                    prefix={<SearchSvg />}
                    style={{ width: 240 }}
                    placeholder='搜索用户名称'
                    onTextChange={(e) => setSearchStr(e)}
                    allowClear
                /> */}
                <div className='ope-icon' onClick={onEditClick}><EditSvg /></div>
                <div className='ope-icon' onClick={onDeleteClick}><DeleteSvg /></div>
            </div>
            <div className="user-table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={displayUsers || []}
                    bordered={false}
                    className='tn-project-table'
                    sticky
                    onRow={row => {
                        return {
                            onClick: () => setActiveItem(row),
                        }
                    }}
                    rowClassName={row => classnames({
                        "user-table-row": true,
                        "user-table-row-active": row.uuid === activeItem?.uuid,
                    })}
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="姓名" width={`${3 / 29 * 100}%`} ellipsis />
                    <Table.Column dataIndex="gender" title="性别" ellipsis width={`${3 / 29 * 100}%`}
                        render={(v) => <div>{v === GENDER_TYPE.MALE ? '男' : '女'}</div>}
                    />
                    <Table.Column dataIndex="positionName" title="职位" width={`${5 / 29 * 100}%`} />
                    <Table.Column dataIndex="mobile" title="电话" width={`${8 / 29 * 100}%`}
                        render={(v) => <div>{v?.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') || ''}</div>}
                    />
                    <Table.Column dataIndex="enterprise" title="单位" width={`${10 / 29 * 100}%`} />
                </Table>
            </div>


            {showAddModal && <AddUserModal showModel={showAddModal} setShowModel={setShowAddModal}
                loading={addLoading} onSuccess={() => {
                    generateData();
                    setShowAddModal(false);
                    setAddLoading(false);
                }} />}

            {showEditModal && <EditUserModal userUuid={activeItem?.uuid} showModel={showEditModal}
                setShowModel={setShowEditModal} loading={editLoading} onSuccess={() => {
                    generateData();
                    setShowEditModal(false);
                    setEditLoading(false);
                }} />}
        </div>
    )
}